import React from 'react'
import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import { LinkedInIcon } from 'assets/icons/LinkedInIcon'
import { PhoneIcon } from 'assets/icons/PhoneIcon'
import { MailIcon } from 'assets/icons/MailIcon'

interface SocialButtonsProps {
  email_address: string
  linkedin_profile_url: string
  phone_number?: string
  showPhone?: boolean
  socialClassName?: string
}

export const SocialButtons = ({
  email_address,
  linkedin_profile_url,
  phone_number,
  socialClassName,
  showPhone = true,
}: SocialButtonsProps) => {
  const iconClasses =
    'bg-white text-[#001A3D] w-4 h-4 rounded-[4px] cursor-pointer hover:text-white hover:border hover:border-[#001A3D] hover:bg-[#001A3D]'

  return (
    <div
      className={`${socialClassName ? socialClassName : 'flex gap-1 md:mt-3'}`}
    >
      <a href={`mailto:${email_address}`}>
        <MailIcon className={iconClasses} />
      </a>
      <a href={linkedin_profile_url}>
        <LinkedInIcon className={iconClasses} />
      </a>
      {showPhone && (
        <a href={`tel:${phone_number}`}>
          <PhoneIcon className={iconClasses} />
        </a>
      )}
    </div>
  )
}
